import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountShell from '../../../layouts/account/AccountShell';
import CustomerAccountPage from './CustomerAccountPage';
import CustomerDashboardPage from './CustomerDashboardPage';
import AccountCustomerProfile from '../../../components/Account/Customer/MyProfile/MyProfile';
import AccountCustomerFavorite from '../../../components/Account/Customer/FavoriteTesters';
import AccountCustomerFavoriteDetails from '../../../components/Account/Customer/FavoriteTesterDetails';

/* Every /account/customer/* page, inside one AccountShell (mounted once, so the rail persists
   across navigation). Login/status checks happen in the PrivateRoute that renders this. */
const CustomerArea: React.FC = () => (
    <AccountShell>
        <Switch>
            <Route exact path="/account/customer" component={CustomerAccountPage} />
            <Route path="/account/customer/cycle/:cycleId" component={CustomerDashboardPage} />
            <Route path="/account/customer/myprofile" component={AccountCustomerProfile} />
            <Route exact path="/account/customer/favorite" component={AccountCustomerFavorite} />
            <Route path="/account/customer/favorite/:testerId" component={AccountCustomerFavoriteDetails} />
        </Switch>
    </AccountShell>
);

export default CustomerArea;
